import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, Input, Divider } from 'antd';
import { push } from 'connected-react-router';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

// Local
import { login } from 'modules/auth/actions';
import { resetEnv } from 'modules/ui/actions';

import Text from 'components/Text';

const Login = (props) => {
  useEffect(() => {
    if (!props.auth.token) {
      props.resetEnv();
    }
  }, []) // eslint-disable-line

  useEffect(() => {
    if (props.auth.token) {
      push('/products')
    }
  })

  useEffect(() => {
    if (props.auth.token) {
      push('/products')
    }
  }, [props.auth])

  const [form, setForm] = useState({
    email: null,
    password: null,
  })

  const handleOnSubmit = (e) => {
    e.preventDefault();
    props.login({
      email: form.email,
      password: form.password
    })
  }
  
  return (
    <>
      <form style={{ maxWidth: 400, margin: 'auto', marginTop: 40 }} onSubmit={handleOnSubmit}>
        <h1>{props.t('Client.Auth.Login.Title', `Connexion à l'espace client`)}</h1>
        {props.t('Client.Auth.Login.Form.Email', `Adresse E-mail`)}
        <Input placeholder='email' onChange={(e) => setForm({...form, email: e.target.value })}/>

        <div style={{ height: 20 }} />

        {props.t('Client.Auth.Login.Form.Password', `Mot de passe`)}
        <Input.Password type="password" placeholder='password' onChange={(e) => setForm({...form, password: e.target.value})}/>

        <div style={{ height: 20 }} />
        <Button type="primary" htmlType="submit" loading={props.auth.loginProcess}>{props.t('Client.Auth.Login.Form.Button', `Connexion`)}</Button>
      </form>

      <Divider>ou</Divider>
      <Text align="center">
        <Link to={`/auth/forgot`}>
          {props.t('Client.Auth.Login.GetPassword', `Premiere connexion / Mot de passe oublié`)}
        </Link>
      </Text>
    </>
  )
}

const stateToProps = state => ({
  auth: state.auth,
})

const dispatchToProps = {
  login,
  resetEnv
}

export default connect(stateToProps, dispatchToProps)(withTranslation()(Login));